module.exports = __webpack_public_path__ + "img/1f952.ef0f34e.svg";